import { useTranslation } from "react-i18next";

import NotFound from "components/NotFound/NotFound";
import { ICONS } from "components/BaseComponents/Image";
import { ElementWrapper } from "components/BaseComponents/Flex";

const NotFoundScreen = () => {
  const { t } = useTranslation();

  return (
    <ElementWrapper
      minHeight='calc(100vh - 137px)'
      width='872px'
      direction='column'
    >
      <NotFound
        info={t("404_not_found_info").toString()}
        srcSet={ICONS.INFO}
        title={t("404_not_found_title").toString()}
      />
    </ElementWrapper>
  );
};

export default NotFoundScreen;
